import notFoundCtrl from 'components/404/404Ctrl';
import appCtrl from 'components/app/appCtrl';
import developersCtrl from 'components/developers/developersCtrl';
import inactiveCtrl from 'components/inactive/inactiveCtrl';
import loginCtrl from 'components/login/loginCtrl';
import membershipCtrl from 'components/membership/membershipCtrl';
import salesCtrl from 'components/sales/salesCtrl';
import settingsCtrl from 'components/settings/settingsCtrl';
import signupCtrl from 'components/signup/signupCtrl';
import trackingCtrl from 'components/tracking/trackingCtrl';
import stripeConnectSuccessCtrl from 'components/stripeConnectSuccess/stripeConnectSuccessCtrl';

function init(app) {
  if (!app) throw new Error('app is required');

  app.controller('404Ctrl', notFoundCtrl);
  app.controller('appCtrl', appCtrl);
  app.controller('developersCtrl', developersCtrl);
  app.controller('inactiveCtrl', inactiveCtrl);
  app.controller('loginCtrl', loginCtrl);
  app.controller('membershipCtrl', membershipCtrl);
  app.controller('salesCtrl', salesCtrl);
  app.controller('settingsCtrl', settingsCtrl);
  app.controller('signupCtrl', signupCtrl);
  app.controller('trackingCtrl', trackingCtrl);
  app.controller('stripeConnectSuccessCtrl', stripeConnectSuccessCtrl);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/components/index.js